import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, forwardRef, Output, EventEmitter, ViewChild, ElementRef, Input } from '@angular/core';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { Observable } from 'rxjs';
import { AdjuntoService } from 'src/app/services/adjunto.service';
import { IdiomaService } from 'src/app/services/idioma.service';
import { Adjunto, AdjuntoSeleccionado } from 'src/app/mantenimiento/models/adjunto';
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.css']
})
export class UploadFileComponent implements OnInit {

  public files: NgxFileDropEntry[] = [];

  @ViewChild('fileSelector', { static: true })
  public fileSelector: ElementRef;

  @Output() archivoSeleccionado = new EventEmitter<AdjuntoSeleccionado>();

  // textos
  public t: any;
  public textos$: Observable<any>;

  @Input() leyenda: string = 'arrastrarysoltar';
  @Input() allowedExtensions: string[] | null = null;
  @Input() maxSizeMb: number | null = null;

  constructor(
    protected http: HttpClient,
    private _idioma: IdiomaService,
    private _adjunto: AdjuntoService,
    private _toastr: ToastrService
  ) {
  }

  ngOnInit(): void {
    this.textos$ = this._idioma.getTextos$();
    this.textos$.subscribe(texto => {
      this.t = texto;
    });
  }

  public guardarLosArchivos(modulo: string, id_objeto: string, adjuntos: Adjunto[]): void {
    for (const adjunto of adjuntos) {
      const item = this.files.filter(a => a.relativePath === adjunto.nombre);
      if (item.length > 0 && (!adjunto.id || adjunto.id == 0)) {
        const fileEntry = item[0].fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {

          this._adjunto.create(modulo, id_objeto, item[0].relativePath, file).subscribe(res => {
            // console.log('archivo subido', adjunto.nombre);
          });
        });
      }
    }
  }

  public openFileSelector = (event?: MouseEvent): void => {
    if (this.fileSelector && this.fileSelector.nativeElement) {
      (this.fileSelector.nativeElement as HTMLInputElement).click();
    }
  }

  public dropped(files: NgxFileDropEntry[]): void {

    for (const droppedFile of files) {
      if (!droppedFile.fileEntry.isFile) continue;

      const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;

      fileEntry.file((file: File) => {
        if (this.allowedExtensions && this.allowedExtensions.length > 0) {
          const fileExtension = file.name.toLowerCase().split('.').pop() || '';

          if (!this.allowedExtensions.includes(fileExtension)) {
            this._toastr.error(
              this.t.formatoinvalido
                && this.t.formatoinvalido.replace('{ext}', this.allowedExtensions.join(', ').toLocaleUpperCase())
            );
            return;
          }
        }

        if (this.maxSizeMb && this.maxSizeMb > 0) {
          const maxBytes = this.maxSizeMb * 1024 * 1024;

          if (file.size > maxBytes) {
            this._toastr.error(
              this.t.archivotamañomaximo 
                ? this.t.archivotamañomaximo.replace('{mb}', String(this.maxSizeMb))
                : `El archivo supera el tamaño máximo de ${this.maxSizeMb}MB`
            );
            return;
          }
        }

        this.files = this.files.filter(a => a.relativePath !== droppedFile.relativePath);
        this.files.push(droppedFile);

        this.archivoSeleccionado.emit({
          nombre: droppedFile.relativePath
        });

      });
    }
  }

  public obtenerArchivo(nombre: string) : any{
    //console.log(this.files)
    return this.files.filter(a => a.relativePath === nombre)[0];
  }
}
